import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { ReactNode } from 'react';

interface Props {
  readonly h1?: boolean;
  readonly className?: string;
  readonly children: ReactNode;
  readonly small?: boolean;
}

const Title = ({ h1, className, children, small, ...props }: Props) => (
  <Typography
    data-cy="lp-title"
    Element={h1 ? 'h1' : 'h2'}
    variant={small ? 'h2' : 'h1'}
    color="inherit"
    className={className!}
    {...props}
  >
    {children}
  </Typography>
);

export default Title;
